// extracted by mini-css-extract-plugin
export default {"layout":"IndexLayout_layout__+TTCA","content":"IndexLayout_content__s2t2R","page":"IndexLayout_page__8clYq","title":"IndexLayout_title__cwqZN","cake":"IndexLayout_cake__B7g4-"};